module.exports = __webpack_public_path__ + "static/media/image.45ac5b99.webp";